export default "__VITE_ASSET__DvA0$DFo__"